import { render, staticRenderFns } from "./tasklist.vue?vue&type=template&id=1805756e&scoped=true"
import script from "./tasklist.vue?vue&type=script&lang=ts"
export * from "./tasklist.vue?vue&type=script&lang=ts"
import style0 from "./tasklist.vue?vue&type=style&index=0&id=1805756e&prod&lang=css"
import style1 from "./tasklist.vue?vue&type=style&index=1&id=1805756e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1805756e",
  null
  
)

export default component.exports